// Sparkly mood emojis with labels
export const MOOD_EMOJIS = [
  { emoji: "uncloned", label: "UnCloned®", value: "uncloned", isCustom: true, imageSrc: "/mood-uncloned.png" },
  { emoji: "✨", label: "Magical", value: "magical" },
  { emoji: "🌟", label: "Amazing", value: "amazing" },
  { emoji: "💖", label: "Loved", value: "loved" },
  { emoji: "🔥", label: "On Fire", value: "on_fire" },
  { emoji: "🌈", label: "Hopeful", value: "hopeful" },
  { emoji: "💫", label: "Dreamy", value: "dreamy" },
  { emoji: "🦋", label: "Free", value: "free" },
  { emoji: "🌸", label: "Peaceful", value: "peaceful" },
  { emoji: "⚡", label: "Energized", value: "energized" },
  { emoji: "🌙", label: "Calm", value: "calm" },
  { emoji: "💭", label: "Thoughtful", value: "thoughtful" },
  { emoji: "🎯", label: "Focused", value: "focused" },
  { emoji: "😴", label: "Tired", value: "tired" },
  { emoji: "🌧️", label: "Melancholy", value: "melancholy" },
  { emoji: "💪", label: "Strong", value: "strong" },
  { emoji: "😤", label: "Angry", value: "angry" },
  { emoji: "😢", label: "Sad", value: "sad" },
  { emoji: "🙏", label: "Grateful", value: "grateful" },
  { emoji: "🎨", label: "Creative", value: "creative" },
];

// Motivational YouTube videos (curated list)
export const MOTIVATIONAL_VIDEOS = [
  // Original videos
  { id: "gwhbt8dWvN4", title: "Motivation Video 1" },
  { id: "OKJImnk-gzQ", title: "Motivation Video 2" },
  { id: "gzPjH3Ts9uU", title: "Motivation Video 3" },
  { id: "yBrRpb8aLwk", title: "Motivation Video 4" },
  { id: "b-Pn0yXL9y8", title: "Motivation Video 5" },
  // New videos added
  { id: "g-jwWYX7Jlo", title: "Motivation Video 6" },
  { id: "nDqMPPLtPIo", title: "Motivation Video 7" },
  { id: "skj-ALA1HFE", title: "Motivation Video 8" },
  { id: "FJHgNXf89f4", title: "Motivation Video 9" },
  { id: "JTTd81BnyUk", title: "Motivation Video 10" },
  { id: "mgmVOuLgFB0", title: "Motivation Video 11" },
  { id: "wnHW6o8WMas", title: "Motivation Video 12" },
  { id: "26U_seo0a1g", title: "Motivation Video 13" },
  { id: "gWyXGT9GLV0", title: "Motivation Video 14" },
  { id: "zUyvKsJnzNw", title: "Motivation Video 15" },
  { id: "ERClHCOF14c", title: "Motivation Video 16" },
  { id: "7uzynHWxn5Q", title: "Motivation Video 17" },
  { id: "AjZ0KbJcav0", title: "Motivation Video 18" },
];
